import type { DiskStatistics } from '@ecowheels/types';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Free disk space on the server.
 *
 * This matters more than it looks: job photos are stored as bytea inside
 * Postgres, so the disk fills as customers submit forms, and a full disk takes
 * the database down with it. Plan 02 moves the files to Storage, after which
 * this bar is far less interesting.
 */
export function StatsBar() {
  const { data } = useQuery({
    queryKey: ['statistics'],
    queryFn: () => api.get<DiskStatistics>('/admin/statistics'),
    refetchInterval: 60_000,
  });

  if (!data) return null;

  const free = Number(data.free);
  const size = Number(data.size);
  const usedPct = size > 0 ? Math.round(((size - free) / size) * 100) : 0;
  const low = free < 2;

  return (
    <div className="border-b border-white/10 bg-white/[0.02]">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2 text-xs">
        <span className="text-white/50">Szabad tárhely:</span>
        <span className={low ? 'font-semibold text-red-400' : 'text-white/80'}>
          {data.free} GB / {data.size} GB
        </span>
        <div className="h-1.5 w-32 overflow-hidden rounded-full bg-white/10">
          <div
            className={`h-full ${low ? 'bg-red-500' : 'bg-brand'}`}
            style={{ width: `${usedPct}%` }}
          />
        </div>
        {low && <span className="text-red-400">Kevés a szabad hely!</span>}
      </div>
    </div>
  );
}
